import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/common/icon_back.png'
import _imports_1 from '@/assets/home/notice_bar_speaker.png'
import _imports_2 from '@/assets/games/wallet.png'


import { ref } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'gameHeaderBar',
  props: {
    noticeText: {},
    isFavorite: { type: Boolean }
  },
  emits: ['backClick', 'showDepositPopup', 'addFavorite'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const handleBackClick = () => {
    emits('backClick')
}

const addFavorite = () => {
    emits('addFavorite')
}

const navDeposit = () => {
    emits('showDepositPopup')
}


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_notice_bar = _resolveComponent("van-notice-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createBlock(_component_van_row, { class: "header_bar" }, {
    default: _withCtx(() => [
      _createVNode(_component_van_col, {
        span: "2",
        class: "backIcon",
        style: {"display":"flex","justify-content":"center","align-items":"center"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: handleBackClick
          })
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, { span: "18" }, {
        default: _withCtx(() => [
          _createVNode(_component_van_notice_bar, {
            class: "notice_container",
            scrollable: "",
            speed: "50",
            text: _ctx.noticeText
          }, {
            "left-icon": _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              }, null, -1)
            ])),
            _: 1
          }, 8, ["text"])
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, {
        span: "2",
        style: {"display":"flex","justify-content":"center","align-items":"center"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "startIcon",
            onClick: addFavorite,
            style: _normalizeStyle({ background: _ctx.isFavorite ? 'linear-gradient(135deg, #ff940b, #ffee00)' : 'linear-gradient(135deg, #9c6e31, #ffcb5c)' })
          }, [
            _createVNode(_component_van_icon, {
              name: "star",
              size: "2vh",
              color: "#27190D"
            })
          ], 4)
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, {
        span: "2",
        class: "walletIcon",
        style: {"display":"flex","justify-content":"center","align-items":"center"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_2,
            onClick: navDeposit,
            alt: ""
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})